
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/megastory",
      function () {
        return require("private-next-pages/megastory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/megastory"])
      });
    }
  